exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pac-container:after {\n  /* Disclaimer: not needed to show 'powered by Google' if also a Google Map is shown */\n\n  background-image: none !important;\n  height: 0px;\n}\n", ""]);

// exports
